<template>
    <BaseModal
        :isVisible="modalVisible"
        :title="`Detalhes do Erro #${selectedLog ? selectedLog.id : 0}`"
        size="xl"
        @close="$emit('close')"
    >
        <template v-slot:content>
            <div v-if="selectedLog">

                <!-- Informações do Erro -->
                <SectionContainer
                    title="Informações do Erro"
                    icon="exclamation-circle"
                >
                    <div class="integration-details">
                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-hashtag"></i>
                                ID:
                            </div>
                            <div class="detail-value">
                                <strong>{{ selectedLog.id }}</strong>
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-signal"></i>
                                Status HTTP:
                            </div>
                            <div class="detail-value">
                                <span
                                    class="badge"
                                    :class="getStatusClass(selectedLog.status_code)"
                                >
                                    {{ selectedLog.status_code }}
                                </span>
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-comment-dots"></i>
                                Mensagem:
                            </div>
                            <div class="detail-value">
                                {{ selectedLog.error_message || 'Erro desconhecido' }}
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-link"></i>
                                URL:
                            </div>
                            <div class="detail-value" style="word-break: break-all;">
                                {{ selectedLog.url }}
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-cog"></i>
                                Método HTTP:
                            </div>
                            <div class="detail-value">
                                <span class="badge badge-info">{{ selectedLog.method }}</span>
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-user"></i>
                                Usuário:
                            </div>
                            <div class="detail-value">
                                {{ selectedLog.user_id || 'Não autenticado' }}
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-map-marker-alt"></i>
                                IP:
                            </div>
                            <div class="detail-value">
                                {{ selectedLog.ip || 'N/A' }}
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-desktop"></i>
                                User Agent:
                            </div>
                            <div class="detail-value" style="word-break: break-all; font-size: 0.85rem;">
                                {{ selectedLog.user_agent || 'N/A' }}
                            </div>
                        </div>

                        <div class="detail-row mb-0">
                            <div class="detail-label">
                                <i class="fas fa-clock"></i>
                                Data/Hora:
                            </div>
                            <div class="detail-value">
                                {{ formatDateTime(selectedLog.created_at) }}
                            </div>
                        </div>
                    </div>
                </SectionContainer>

                <!-- Request Body -->
                <SectionContainer
                    title="Dados da Requisição (Request Body)"
                    icon="arrow-up"
                    class="mt-4"
                >
                    <div class="json-container">
                        <div class="copy-button-container">
                            <button
                                class="btn btn-sm btn-outline-primary"
                                @click="copyToClipboard('request')"
                            >
                                <i class="fas fa-copy mr-1"></i>
                                {{ copiedStates.request ? 'Copiado!' : 'Copiar Request' }}
                            </button>
                        </div>
                        <pre class="json-content">{{ formatJson(selectedLog.request_body) }}</pre>
                    </div>
                </SectionContainer>

                <!-- Response Data -->
                <SectionContainer
                    title="Dados da Resposta (Response)"
                    icon="arrow-down"
                    class="mt-4"
                >
                    <div class="json-container">
                        <div class="copy-button-container">
                            <button
                                class="btn btn-sm btn-outline-primary"
                                @click="copyToClipboard('response')"
                            >
                                <i class="fas fa-copy mr-1"></i>
                                {{ copiedStates.response ? 'Copiado!' : 'Copiar Response' }}
                            </button>
                        </div>
                        <pre class="json-content">{{ formatJson(selectedLog.response_data) }}</pre>
                    </div>
                </SectionContainer>

            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../Base/BaseModal.vue"
import SectionContainer from "../Modals/Checklist/SectionContainer.vue"
import moment from 'moment'

export default {
    name: 'ModalDetails',

    components: {
        BaseModal,
        SectionContainer
    },

    props: {
        modalVisible: {
            type: Boolean,
            default: false
        },
        selectedLog: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            copiedStates: {
                request: false,
                response: false
            }
        }
    },

    methods: {
        formatDateTime(date) {
            if (!date) return '-'
            return moment(date).format('DD/MM/YYYY HH:mm:ss')
        },

        getStatusClass(statusCode) {
            if (statusCode >= 500) {
                return 'badge-danger'
            } else if (statusCode >= 400) {
                return 'badge-warning'
            }
            return 'badge-secondary'
        },

        formatJson(data) {
            if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
                return 'Nenhum dado disponível'
            }

            if (typeof data === 'string') {
                try {
                    const parsed = JSON.parse(data)
                    return JSON.stringify(parsed, null, 2)
                } catch (e) {
                    return data
                }
            }

            // Se já é objeto, converte para JSON formatado
            return JSON.stringify(data, null, 2)
        },

        async copyToClipboard(type) {
            const data = type === 'request'
                ? this.selectedLog.request_body
                : this.selectedLog.response_data

            try {
                await navigator.clipboard.writeText(this.formatJson(data))
                this.copiedStates[type] = true

                setTimeout(() => {
                    this.copiedStates[type] = false
                }, 2000)
            } catch (err) {
                console.error('Erro ao copiar:', err)
            }
        }
    }
}
</script>

<style scoped>
.integration-details {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.detail-row {
    display: flex;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #667eea;
}

.detail-label {
    flex: 0 0 180px;
    font-weight: 600;
    color: #495057;
}

.detail-label i {
    margin-right: 8px;
    color: #667eea;
    width: 16px;
}

.detail-value {
    flex: 1;
    color: #212529;
}

.json-container {
    position: relative;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
}

.copy-button-container {
    text-align: right;
    margin-bottom: 10px;
}

.json-content {
    background: #2d3748;
    color: #68d391;
    padding: 20px;
    border-radius: 8px;
    overflow-x: auto;
    max-height: 400px;
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiErrorLog/ModalDetails.vue